import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormatConfigService } from 'app/core/services/format-config.service';
import { CapiLoginService } from '../login/capi-login-service';
import { CapAlertService } from '../exceptions/cap-alert.service';
import { AppConfigService } from '../../services/app-config.service';
import { IntercapiSpracheContent } from '../../base-api';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle
} from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';


@Component({
  selector: 'cap-user-picker',
  templateUrl: './user-picker.component.html',
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgClass, TranslatePipe]
})
export class UserPickerComponent implements OnInit, OnDestroy {
  private languageNames = {
    'en': 'English',
    'de': 'Deutsch',
    'fr': 'Français',
    'it': 'Italiano',
    'rm': 'Rumantsch Grischun'
  };
  isLoginDisabled = false;
  selectedLanguage: string;
  versionInfo: string;
  languages: string[] = ['de'];

  @Input()
  isICP = false;

  private subscription: Subscription[] = [];
  private intercapiSpracheParam: IntercapiSpracheContent;

  constructor(public translateService: TranslateService,
              public loginService: CapiLoginService,
              private capAlertService: CapAlertService,
              private translate: TranslateService,
              private appConfigService: AppConfigService,
              private appFormatConfigService: FormatConfigService) {
  }

  ngOnInit(): void {
    this.configureAvailableLanguages();
    this.isLoginDisabled = !this.loginAllowed();
    this.versionInfo = this.translate.instant('version') + ' ' + this.translate.instant('layouts.page.title') + ' ' + this.appConfigService.versionNr;
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  private configureAvailableLanguages = (): void => {
    if (this.isICP && !this.languages.includes('fr')) {
      this.languages.push('fr');
    } else {
      this.subscription.push(this.appFormatConfigService.parameterConfig$.subscribe(config => {
        this.intercapiSpracheParam = (<any>config?.parameters.INTERCAPI_SPRACHE)?.content as IntercapiSpracheContent;
        if (this.intercapiSpracheParam) {
          if (!this.intercapiSpracheParam.deutsch && this.languages.includes('de')) {
            this.languages.pop();
          }
          if (this.intercapiSpracheParam.franzoesisch && !this.languages.includes('fr')) {
            this.languages.push('fr');
          }
          if (this.intercapiSpracheParam.italienisch && !this.languages.includes('it')) {
            this.languages.push('it');
          }
          this.selectedLanguage = this.translateService.getCurrentLang();
          if (!this.languages.includes(this.selectedLanguage)) {
            this.selectLanguage(this.languages[0]);
          }
        }
      }));
    }
  };

  public languageName(language: string) {
    return this.languageNames[language] || language;
  }

  selectLanguage(language: string): void {
    this.translateService.use(language);
    this.selectedLanguage = language;
  }

  info() {
    this.capAlertService.info(this.versionInfo);
  }

  loginAllowed(): boolean {
    let anonym: boolean = false;
    this.subscription.push(this.appFormatConfigService.parameterConfig$.subscribe(config => {
      anonym = (<any>config?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN)?.content === 'ANONYM';
    }));
    if (this.isICP) {
      return !anonym;
    }
    return true;
  }

  public loginLogout() {
    this.loginService.userLoggedIn ? this.loginService.logout() : this.loginService.login();
  }

}
